import { useTranslations } from '@aikoa/i18n/react'
import { useRouter } from 'expo-router'
import { useState } from 'react'
import { FeedbackFlow } from '~/components/feedback/FeedbackFlow'
import Icon from '~/components/Icon'
import ContentBox from '~/components/layout/ContentBox'
import ScreenView from '~/components/layout/ScreenView'
import { SectionContent } from '~/components/layout/Sections'
import { LoadingView } from '~/components/LoadingView'
import { Heading2 } from '~/components/typography/Titles'
import { LinkButton, ButtonLabel } from '~/components/ui/button'
import { useLatestRespondedFeedback } from '~/data/feedback/useFeedback'
import { useInterest } from '~/data/interests/useInterests'
import { ConfettiTrigger } from '~/lib/ConfettiProvider'

export default function UpdateSearch() {
  return (
    <ScreenView>
      <UpdateSearchContent />
    </ScreenView>
  )
}

function UpdateSearchContent() {
  const { t } = useTranslations('feedback')
  const router = useRouter()
  const { data: latestFeedback, isLoading } = useLatestRespondedFeedback()
  const { data: interest } = useInterest()
  const [isComplete, setIsComplete] = useState(false)

  if (isLoading) {
    return <LoadingView />
  }

  if (!latestFeedback) {
    return (
      <ContentBox contentContainerClassName="gap-6">
        <Heading2 className="text-center font-bold text-2xl">
          {t(($) => $.buyer.updateSearchTitle)}
        </Heading2>
        <SectionContent>{t(($) => $.buyer.noPreviousFeedback)}</SectionContent>
        <LinkButton variant="primary" href="/(authenticated)">
          <ButtonLabel>{t(($) => $.flow.back)}</ButtonLabel>
        </LinkButton>
      </ContentBox>
    )
  }

  if (isComplete) {
    return (
      <ContentBox contentContainerClassName="relative gap-6">
        <ConfettiTrigger
          confettiKey="buyer-search-updated"
          className="mb-2 size-[64px] items-center self-center">
          <Icon name="checkmark-circle" size={64} className="text-secondary" />
        </ConfettiTrigger>
        <Heading2 className="text-center font-bold text-3xl">
          {t(($) => $.buyer.updateSearchSuccessTitle)}
        </Heading2>
        <SectionContent textClassName="text-pretty text-lg/normal">
          {t(($) => $.buyer.updateSearchSuccessDescription)}
        </SectionContent>
        <LinkButton variant="primary" href="/(authenticated)">
          <ButtonLabel>{t(($) => $.flow.back)}</ButtonLabel>
        </LinkButton>
      </ContentBox>
    )
  }

  return (
    <FeedbackFlow
      flowId="buyer-search-update"
      initialTimingAnswer={latestFeedback.timingAnswer}
      initialInterestData={interest?.data ?? null}
      flowTitle={t(($) => $.buyer.updateSearchTitle)}
      onComplete={(outcome) => {
        if (outcome === 'completed') {
          setIsComplete(true)
        }
      }}
      onClose={() => router.back()}
    />
  )
}
